<carousel *ngIf="isBlogsAvailable">
  <div class="col-md-12">
    <slide *ngFor="let blog of blogsArray">
      <div class="row carousel-flex">
        <div class="image-carousel">
          <img [src]="getImgUrl(blog.blogId)" (error)="imgError($event)" alt="">
        </div>
        <div class="description-carousel">
          <div class="carousel-caption">
            <h2 class="title">{{blog.name}}</h2>
            <p class="description" [innerHTML]="blog.description | safeHtml"></p>
            <div class="read-more-container">
              <a class="read-more-link" (click)="goToBlog(blog.blogId)">{{'Read More' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="thumb-title">
        <p class="nomargin">{{'Spotlight' | translate}}</p>
        <p class="nomargin">{{'on Immunotherapy' | translate}}</p>
      </div>
    </slide>
  </div>
</carousel>
